jQuery(document).ready(function($) {
  var 
  menu_link = $('.widget_nav_menu .menu .menu-item-has-children > a'),
  sub_menu = $('.widget_nav_menu .menu li .sub-menu');   
  
  console.log(menu_link);

  menu_link.on('click', function() {
    if (!$(this).hasClass('active')) {
	  event.preventDefault();
      sub_menu.slideUp(300,'swing');
	  $(this).next().stop(true,true).slideToggle(300);
      menu_link.removeClass('active');
      $(this).addClass('active');
    } 
    else {
      sub_menu.slideUp(300);
      menu_link.removeClass('active');
    }
    
  });
  
});


jQuery(".widget_nav_menu h4").click(function(){
  jQuery(".widget_nav_menu").toggleClass('active');
}); 
